import { GEO_MODEL } from 'utils/models';
import api from './api';
import { ALERTAS_ROUTE, GEO_ROUTE } from '../constants/apiRoutes';

export default {
	async findGeoByAlertaId(id) {
		const { data } = await api.get(ALERTAS_ROUTE.FIND_BY_ID.replace('{alertaId}', id));

		let { geo } = data;

		geo = geo || GEO_MODEL;
		geo.alertaId = data.id;
		geo.alertaStatus = data.statusAtualAlerta;

		return geo;
	},

	async saveGeo(geo, cb) {
		cb();
		api.post(GEO_ROUTE.SAVE_GEO, geo);
	},

	async getResultIntersection(geometry, alertaId, updateStateAfterGetIntersection, cb) {
		const { data } = await api.post(GEO_ROUTE.GET_INTERSECTION, geometry);

		/*
            Atualiza o estado da página do mapa, antes de retornar os dados
            por callback, para o componente de mapa
        */
		updateStateAfterGetIntersection(data, alertaId);

		cb(data);
	},
};
